export default __webpack_public_path__ + "static/media/Background_00048.b4f7e9ee.png";